import React, { useState, useRef, useReducer } from "react";
import Box from "@mui/material/Box";
import { Skeleton, Typography } from "@mui/material";
import MuiTab from "../../CommonComponents/Tab/MuiTab";
import CommonDescription from "../../CommonComponents/CommonDescription";
import useMediaQuery from "@mui/material/useMediaQuery";
import TableComponent from "../../CommonComponents/Table";
import CommonButton from "../../CommonComponents/CommonButton";
// import AddIcon from "@mui/icons-material/Add";
import AddIcon from "../../Images/Svg/AddIconButton.svg";
// import DownloadIcon from "@mui/icons-material/Download";
import DownloadIcon from "../../Images/Svg/DownloadIcon.svg";

import TableGrid from "../../CommonComponents/TableGridView/TableGrid";
import {
  tabs2CaseManagement,
  CaseManagementMainTableData,
  assignBlock,
  tabs2CaseManagementVendor,
  vendorDetialGrid,
  tabs2CaseManagementRecommended,
  tabs2CaseManagementSubmitted,
  dropDownOptions,
} from "../../constants/caseManagementData";
import {
  defaultCaseActionList,
  openCaseActionList,
  allocatedCaseActionList,
  qcCaseActionList,
  queryCaseActionList,
  recommendedCaseActionList,
  submittedCaseActionList,
  rejectedCaseActionList,
  openCaseRecommendationList,
  motorTriggerTable,
  segmentInfoDetails,
} from "../../constants/utils";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import RaiseQueryModal from "./Actions/RaiseQueryModal";
import DragDrop from "../../CommonComponents/DragDrop/DragDrop";
import ReAssignModal from "./Actions/ReAssign";
import ReAssignCaseModal from "./Actions/ReassignCase";
import GradeCaseModal from "./Actions/GradeCase";
import CaseDescription from "./Actions/CaseDescription/CaseDescription";
import CommonModal from "../../CommonComponents/Modal/CommonModal";
import { useCallback } from "react";
import Approval from "./Actions/Approval";
import Reject from "./Actions/Reject";
import VendorAssesment from "./Actions/AssesmentCalculator";
import UploadDocument from "./Actions/UploadDoucument/UploadDocument";
import { uploadOptions, options } from "../../constants/utils";
import FilterPopOver from "./CaseManagementFilter/FilterPopOver";
import style from "./CaseManagement.module.css";
import CheckboxLabels from "../../CommonComponents/CheckboxLabel/CheckboxLabels";

import {
  dateReducer,
  filterStatusReducer,
} from "../../Redux/Slice/FilterSlice";
import { getAllCasesCount } from "../../Services/case.service";
import { uploadDocument } from "../../Services/upload.service";
import {
  approveAction,
  holdUnholdApi,
  vendorDetailInfoOFAllocated,
  withdrawalCase,
} from "../../Services/caseManagement.service";
import { setCaseActions } from "../../Redux/Slice/CaseManagementMenuSlice";
import { getCaseManagementTablistItems, pageLimit } from "../../Utils/helper";
import {
  assignedBlocks,
  caseDescriptionPut,
  getAllCasesList,
  getAllCasesSegmentInfo,
  rejectCase,
} from "../../Services/caseManagement.service";
import {
  approvalFlagPutApi,
  getDeEmpanelSegmentInfo,
  getVendorAssessmentData,
} from "../../Services/approval.service";
import useToaster from "../../customHook/useToaster";
import {
  storeCaseId,
  storeIsAllocatedCase,
} from "../../Redux/Slice/CaseManagementActionsSlice/CaseDescriptionSlice";
import ExternalInformation from "../../CommonComponents/ExternalInformation";
import Loader from "../../CommonComponents/Loader/Loader";
import { isLoadingStateReducer } from "../../Redux/Slice/loginSlice";
import RecommendationTabelGrid from "../../CommonComponents/TableGridView/RecommendationTabelGrid";
import { getRlmuData } from "../../Services/de-empanel.service";
import { debounce } from "lodash";
import { Fragment } from "react";
import TableSkeleton from "../../CommonComponents/TableSkeleton";
import TableGridSkeleton from "../../CommonComponents/TableGridSkeleton";
import PeerReview from "./Actions/PeerReview/PeerReview";
import PromptModal from "../../CommonComponents/PromptModal/PromptModal";
import Investigation from "../Approval/Investigation/Investigation";
import ReasonModal from "../../CommonComponents/Modal/ReasonModal";

const boxStyle = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  width: "100%",
  ml: { sx: "0", sm: "2.4rem", md: "2.4rem" },
  mt: { sx: "0", sm: "2.4rem", md: "2.4rem" },
};
const boxStyleTab = {
  width: "auto",
  marginLeft: "2.4rem",
  // mt:"5.1rem",
};
let buttonStyle = {
  fontSize: "2.8rem",
  paddingTop: "0.4rem",
  paddingBottom: "0.4rem",
};
const createCaseStyle = {
  fontSize: "1.2rem",
  fontWeight: "500",
};
const match1 = {
  width: "100%",
  marginLeft: "-1.9rem",
  // flexDirection:"column-reverse",
  display: "flex",
  marginBottom: "9px",
};
const match2 = {
  width: "100%",
  marginLeft: "-1.9rem",
  flexDirection: "column-reverse",
  display: "flex",
};
const CaseManagement = () => {
  // assign block state
  const [dropDownValue, setDropDownValue] = useState("Select");
  //Upload state

  const [caseManagementDataState, setCaseManagementDataState] = useState([]);
  const [tableCollapseDataState, setTableCollapseDataState] = useState([]);
  const [caseManagementSegmentInfoState, setCaseManagementSegmentInfoState] =
    useState({});
  const [rerenderSegmentApiState, setRerenderSegmentApiState] = useState(false);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const rowsPerPage = pageLimit;
  const [secondTabVal, setSecondTabVal] = useState("Basic Details");
  const [secondTabIndex, setSecondTabIndex] = useState(0);
  const [firstTabVal, setFirstTabVal] = useState(
    useSelector(
      (state) =>
        state.caseManagemenSliceMenu?.caseManagementMenu?.caseManagementMenuTab
    ) || "Open"
  );
  const [firstTabIndex, setFirstTabIndex] = useState(
    useSelector(
      (state) =>
        state.caseManagemenSliceMenu?.caseManagementMenu
          ?.caseManagementMenuTabIndex
    ) || 0
  );
  const [activeCaseId, setActiveCaseId] = useState(0);
  const [openCollapse, setOpenCollapse] = useState();
  const [selectedCollapseId, setSelectedCollapseId] = useState(0);
  const [displaySecondTab, setDisplaySecondTab] = useState(false);
  const [openActionModal, setOpenActionModal] = useState(false);
  const [actionModalType, setActionModalType] = useState("");
  const [reRender, setReRender] = useState(false);

  // case management filter
  const [isDateFilterClicked, setisDateFilterClicked] = useState(false);
  const [isStatusFilterClicked, setisStatusFilterClicked] = useState(false);
  const [isDateIconClicked, setisDateIconClicked] = useState(false);
  const [isStatusIconClicked, setisStatusIconClicked] = useState(false);
  const [isStatusItemClicked, setisStatusItemClicked] = useState(false);
  const [filterSearchData, setFilterSearchData] = useState("");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [showRecommendationModal, setShowRecommendationModal] = useState(false);
  const [AllCasesCount, setAllCasesCount] = useState([]);
  const [actionTabState, setActionTabState] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [recommendationName, setRecommendationName] = useState("");
  const [recommendationData, setRecommendationData] = useState(null);
  const [rlmuData, setRlmuData] = useState([]);
  const [showSkeleton, setShowSkeleton] = useState(false);
  const [timeoutId, setTimeoutId] = useState(null);
  const [investigationsActiveTabValue, setInvestigationActiveTabValue] =
    useState(-1);
  const [vendorBlockisClicked, setVendorBlockIsClicked] = useState(false);
  const [isVendorClicked, setIsVendorClicked] = useState(false);
  const [reAssignModal, setReAssignModal] = useState(false);
  const [vendorDetailIndexNumber, setVendorDetailIndexNumber] = useState(-1);
  const [isHoldCase, setIsHoldCase] = useState();
  const [withdrawAllocationId, setWithdrawAllocationId] = useState("");
  const [withdrawModal, setWithdrawModal] = useState(false);
  const viewTableRef = useRef(null);
  const actionPopperRef = useRef(null);
  const descriptionRef = useRef("");

  const caseActions = useSelector(
    (state) => state?.caseManagemenSliceMenu?.caseActions
  );

  const { caseId, lobName, isAllocatedCase } = useSelector(
    (state) => state?.CaseDescriptionSlice
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const matches = useMediaQuery("(min-width:1200px)"); //new`
  const { showToast } = useToaster();
  const selectedCaseId = useRef(0);
  const userRole = useSelector(
    (state) => state?.loginSlice?.userData?.currentRoleName
  );

  // table
  const onSubmitButton = async (event, newValue) => {
    try {
      const data = await caseDescriptionPut(
        secondTabVal === "CHASE Smart"
          ? "External"
          : secondTabVal.split(" ")[0],
        {
          caseId,
          description: descriptionRef?.current?.value || "",
        }
      );
      if (data?.success) {
        showToast(data?.message, "success", true);
      } else {
        showToast(
          data?.message || "Error in updating description",
          "error",
          true
        );
      }
    } catch (error) {
      showToast(
        error?.response?.data?.message || "Error in updating description",
        "error",
        true
      );
    }
  };

  const onRejectSubmitClick = useCallback(async () => {
    try {
      const data = await rejectCase(caseId, {
        caseId,
      });
      showToast("Case rejected successfully", "success", true);
    } catch (error) {
      showToast("Error in Rejecting case", "error", true);
    }
    setOpenActionModal(false);
  }, [caseId]);
  const firstButtonClicked = useCallback(() => {
    setPage(1);
  }, []);
  const lastButtonClicked = useCallback(() => {
    setPage(Math.ceil(count / rowsPerPage));
  }, [rowsPerPage, count]);
  const handleNextButtonClick = useCallback(() => {
    setPage((page) => page + 1);
  }, []);
  const handleBackButtonClick = useCallback(() => {
    setPage((page) => page - 1);
  }, []);
  const onPageDropdownChange = useCallback((e) => {
    setPage(Number(e.target.value));
  }, []);
  const secondTabChangeClickHandler = useCallback((event, newValue) => {
    setSecondTabVal(event.target.innerText);
    setSecondTabIndex(newValue);
    setSelectedCollapseId(null);
    setOpenCollapse(false);
  }, []);
  const firstTabChangeClickHandler = useCallback((event, newValue) => {
    setCaseManagementDataState([]);
    setFirstTabVal(event.target.innerText.split(" ")[1]);
    setFirstTabIndex(newValue);
    setDisplaySecondTab(false);
    setSecondTabIndex(0);
    setSelectedCollapseId(null);
    setPage(1);
  }, []);

  function caseNumberClick(e, ref) {
    setDisplaySecondTab(true);
    setSecondTabVal("Basic Details");
    setSecondTabIndex(0);
    setSelectedCollapseId(null);
  }
  const gridViewTabs = [
    "Basic Details",
    "Policy Details",
    "Proposal Details",
    "Risk Details",
  ];
  const tabsWithdefaultRLMU = ["QC", "Recommended", "Submitted", "Rejected"];
  const onCellClicked = useCallback(
    (e, colId, colValue, lobName, index, isHold) => {
      if (typeof colValue === "number") {
        selectedCaseId.current = colValue;
        dispatch(storeCaseId({ colValue, lobName }));
      }
      if (secondTabVal === "Vendor Details") {
        if (colValue === "View Blocks") {
          setCaseManagementSegmentInfoState((prev) => {
            if (prev.length) {
              let newArr = [...prev];
              newArr = newArr.map((item, mapIndex) => {
                if (mapIndex === index) item.view_blocks = "Hide Blocks";
                else item.view_blocks = "View Blocks";
                return item;
              });
              return newArr;
            } else {
              return prev;
            }
          });
          setOpenCollapse(index);
        } else if (colValue === "Hide Blocks") {
          setCaseManagementSegmentInfoState((prev) => {
            if (prev.length) {
              let newArr = [...prev];
              newArr[index].view_blocks = "View Blocks";
              return newArr;
            } else {
              return prev;
            }
          });
          setOpenCollapse((prev) => false);
        } else {
          setOpenCollapse((prev) => false);
        }
        if (colValue === "Re-assign") {
          setReAssignModal(true);
          setVendorDetailIndexNumber(index + 1);
        }
        if (colValue === "Withdraw") {
          setWithdrawModal(true);
          setWithdrawAllocationId(
            caseManagementSegmentInfoState[index]?.caseAllocationId
          );
        }
      }
      setSelectedCollapseId(index);
    },
    [caseManagementSegmentInfoState, secondTabVal]
  );

  const ActionTabContent = useCallback((firstTabVal, userRole) => {
    switch (firstTabVal) {
      case "Open":
        let filteredActions = openCaseActionList;
        if (userRole === "RM" || userRole === "NM" || userRole === "NH") {
          filteredActions = filteredActions.filter(
            (item) => item.label === "Hold / Unhold"
          );
        }
        if (userRole === "QC") {
          filteredActions = filteredActions.filter(
            (item) => item.label !== "Assign Block"
          );
        }
        setActionTabState(filteredActions);
        break;
      case "Allocated":
        // let updatedCaseList = allocatedCaseActionList?.filter(
        //   (item) => item?.label !== "Withdrawal"
        // );
        setActionTabState(allocatedCaseActionList);
        break;
      case "QC":
        setActionTabState(qcCaseActionList);
        break;
      case "Query":
        setActionTabState(queryCaseActionList);
        break;
      case "Recommended":
        setActionTabState(recommendedCaseActionList);
        break;
      case "Submitted":
        setActionTabState(submittedCaseActionList);
        break;
      case "Rejected":
        setActionTabState(rejectedCaseActionList);
        break;
      default:
        setActionTabState(defaultCaseActionList);
    }
  }, []);
  const getRecommendationOf = useCallback(
    (caseId, srNo) => {
      caseManagementDataState?.forEach((item) => {
        if (caseId === item?.case_id && srNo === item?.srNo)
          setRecommendationName(item?.recommendation_of);
      });
      return;
    },
    [caseManagementDataState]
  );

  // const onClickFirstPopper = useCallback((e, type) => {
  const holdUnholdApiCall = useCallback(
    (caseId, isHold, selectedValue, remark) => {
      let payload = {
        hold_status: isHold ? "unhold" : "hold",
        hold_reason: !isHold ? selectedValue : "",
        remarks: !isHold ? remark : "",
      };
      dispatch(isLoadingStateReducer(true));
      holdUnholdApi(caseId, payload)
        ?.then((response) => {
          if (response?.success) {
            setReRender(true);
            showToast(response?.message, "success", true);
          }
          dispatch(isLoadingStateReducer(false));
        })
        ?.catch((err) => {
          dispatch(isLoadingStateReducer(false));
          showToast(
            err?.response?.data?.message || "Something went wrong",
            "error",
            true
          );
        });
    },
    []
  );

  const onClickFirstPopper = useCallback(
    (e, type, SrNo, caseId, isHold) => {
      setActiveCaseId(selectedCaseId?.current);
      setIsHoldCase(isHold);
      if (type === "view") {
        setInvestigationActiveTabValue(-1);
        setVendorBlockIsClicked(false);
        setIsVendorClicked(false);
        getRecommendationOf(selectedCaseId?.current, SrNo);
        if (displaySecondTab) {
          setDisplaySecondTab(false);
          setTimeout(() => {
            setDisplaySecondTab(true);
          }, 50);
        } else {
          setDisplaySecondTab(true);
        }
        if (firstTabVal === "Allocated") setSecondTabVal("Vendor Details");
        else if (tabsWithdefaultRLMU?.includes(firstTabVal))
          setSecondTabVal("FCU Actions");
        else setSecondTabVal("Basic Details");
        setSecondTabIndex(0);
        setRerenderSegmentApiState((prev) => !prev);
        setTimeout(() => {
          viewTableRef.current.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "center",
          });
        }, 100);
      } else {
        if (type === "Re-open") {
          // setFirstTabIndex(0);
          // setFirstTabVal("Open");
          // setTimeout(() => {
          //   setReRender((prev) => !prev);
          // }, 100);
          showToast("Coming soon", "info", true);
          return;
        }
        if (type === "Assign Block") {
          navigate("/assignBlock");
          return;
        }
        if (type === "Hold / Unhold" && isHold) {
          holdUnholdApiCall(caseId, isHold);
          return;
        }
        setOpenActionModal(true);
        setActionModalType(type);
        actionPopperRef.current = {
          caseId: selectedCaseId?.current,
          open: true,
        };
      }
    },
    [displaySecondTab, firstTabVal, caseManagementDataState]
  );
  // const onClickSecondPopper = useCallback((e, type) => {
  //   setOpenActionModal(true);
  //   setActionModalType(type);
  // }, []);
  // const onClickSecondPopper = useCallback((e, type) => {
  //   setOpenActionModal(true);
  //   setDropDownValue("Select");
  //   setActionModalType(type);
  // }, []);
  const dropDownSubmitHandler = (selectedValue, remark) => {
    if (selectedValue && remark) {
      holdUnholdApiCall(caseId, isHoldCase, selectedValue, remark);
      setOpenActionModal(false);
      setReRender(true);
    } else {
      showToast("Please fill all the input fields.", "error", true);
    }
  };
  const withdrawalCaseFunc = useCallback(
    (caseid, withdrawReason) => {
      let data = {
        caseId: caseid,
        caseAllocationIds: [withdrawAllocationId],
        withdrawalReason: withdrawReason,
      };
      setWithdrawModal(false);
      dispatch(isLoadingStateReducer(true));
      withdrawalCase(data)
        .then((res) => {
          if (res?.success) {
            dispatch(isLoadingStateReducer(false));
            showToast(res?.message, "success", true);
            setReRender(true);
            setDisplaySecondTab(false);
          }
        })
        .catch((err) => {
          dispatch(isLoadingStateReducer(false));
          showToast(
            err?.response?.data?.message || "Something went wrong",
            "error",
            true
          );
        });
    },
    [dispatch, withdrawAllocationId]
  );

  const isDisabled = useCallback(
    (item) => {
      let disabled = false;
      if (caseActions[item]?.length) {
        disabled = caseActions[item]?.includes(selectedCaseId.current);
      }
      return disabled;
    },
    [caseActions]
  );
  const isCaseApproved = useCallback(
    (flag) => {
      if (flag) {
        approveAction(selectedCaseId.current)?.then((response) => {
          if (response?.success) {
            dispatch(
              setCaseActions({
                actionType: actionModalType,
                caseNo: selectedCaseId.current,
              })
            );
            setOpenActionModal(false);
            showToast("Case approved", "success", true);
          }
        });
        return;
      }
      setOpenActionModal(false);
    },
    [actionModalType, dispatch]
  );
  const onCloseSecondPopper = useCallback(() => {}, []);
  const newCaseClickHandler = useCallback(() => {
    return navigate("/createCase");
  }, []);
  //set toggle for render
  const toggleRender = useCallback(() => {
    setReRender((prev) => !prev);
  }, []);

  const { caseManagementMenuTab, caseManagementMenuTabIndex } = useSelector(
    (state) => state.caseManagemenSliceMenu.caseManagementMenu
  );

  const onAssignBlockHandler = useCallback(() => {
    setOpenActionModal(false);
    toggleRender();
  }, [toggleRender]);

  const actionFactory = useCallback(
    (x) => {
      let component = null;
      switch (x) {
        case "Raise Query":
          component = <RaiseQueryModal />;
          break;
        case "Assign Block":
          component = (
            <DragDrop
              // data={assignBlock}
              label={"Assign Block"}
              // blockCount={`Blocks to be assigned: ${assignBlock?.length}`}
              options={options}
              // handelChange={(e) => setDropDownValue(e.target.value)}
              // valueOfDropDown={dropDownValue}
              onAssign={onAssignBlockHandler}
            />
          );

          break;
        case "Re-Assign":
          component = (
            <ReAssignCaseModal
              onSuccess={() => {
                setOpenActionModal(false);
                setReRender(true);
              }}
            />
          );
          break;
        case "Upload Documents":
          component = (
            <UploadDocument onSuccess={() => setOpenActionModal(false)} />
          );
          break;
        case "Grade Case":
          component = (
            <GradeCaseModal setOpenActionModal={setOpenActionModal} />
          );
          break;
        case "Submit Final":
          component = (
            <Approval
              message="Do you have any recommendations?"
              onClick={(value) => {
                setOpenActionModal(value);
                setReRender(true);
              }}
              isSubmit={true}
            />
          );
          break;
        case "Approve":
          component = <Approval onClick={isCaseApproved} />;
          break;
        case "Vendor Assessment":
          component = <VendorAssesment caseId={caseId} />;
          break;
        case "Reject":
          component = (
            <Reject
              onSubmit={onRejectSubmitClick}
              setOpenActionModal={setOpenActionModal}
            />
          );
          break;
        case "Case Description":
          component = (
            <CaseDescription onSubmit={() => setOpenActionModal(false)} />
          );
          break;
        case "Case History":
          component = <CaseDescription />;
          break;
        case "Peer Review":
          component = (
            <PeerReview
              caseId={caseId}
              onSuccess={() => setOpenActionModal(false)}
            />
          );
          break;
        case "Hold / Unhold":
          if (!isHoldCase) {
            component = (
              <ReasonModal
                reasons={dropDownOptions}
                submitHandler={(selectValue, remark) => {
                  dropDownSubmitHandler(selectValue, remark);
                }}
              />
            );
          }
          break;
        default:
          return "Failed to load";
      }
      return component;
    },
    [onAssignBlockHandler, isCaseApproved, onRejectSubmitClick]
  );

  const renderActionComponent = useCallback(() => {
    return actionFactory(actionModalType);
  }, [actionFactory, actionModalType]);

  useEffect(() => {
    setFirstTabVal(caseManagementMenuTab);
    setFirstTabIndex((prev) => caseManagementMenuTabIndex);
    setDisplaySecondTab(false);
  }, [caseManagementMenuTab, caseManagementMenuTabIndex]);

  // filter

  const dateFilterHandler = () => {
    setisDateFilterClicked(!isDateFilterClicked);
    setisDateIconClicked(!isDateIconClicked);
  };
  const statusFilterHandler = () => {
    setisStatusIconClicked(!isStatusIconClicked);
    setisStatusFilterClicked(!isStatusFilterClicked);
  };
  const statusItemHandler = (option) => {
    setisStatusItemClicked(true);
  };
  const startDateHandler = (value) => {
    // let d = new Date(value);
    // d = `${d.getMonth() + 1}-${d.getDate()}-${d.getFullYear()}`;
    dispatch(dateReducer({ startDate: value }));
  };
  const endDateHandler = (value) => {
    // let d = new Date(value);
    // d = `${d.getMonth() + 1}  -${d.getDate()}-${d.getFullYear()}`;
    dispatch(dateReducer({ endDate: value }));
  };
  const handleFilterByTag = (e) => {
    if (e.keyCode === 13) {
      setFilterSearchData(e.target.value);
    }
  };

  const handleClick = (event) => {
    return showToast("Coming soon", "info", true);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleFilterReset = () => {
    setFilterSearchData("");
    dispatch(dateReducer({ startDate: "", endDate: "" }));
    dispatch(filterStatusReducer(""));
  };
  const handleFilterApply = (e) => {
    setAnchorEl(null);
  };

  const getAllCasesSegmentInfoFun = useCallback(
    async (secondTabVal) => {
      try {
        if (secondTabVal === "Vendor Details") {
          const { data } = await vendorDetailInfoOFAllocated({
            caseId: selectedCaseId.current,
          });
          const venderDetailSegmentInfoData =
            data?.assignedToInvestigatorsWithInvestigationStatus.map(
              (item, i, arr) => {
                if (item?.investigationStatus === "pending") {
                  item.investigationStatus = "Pending";
                } else if (item?.investigationStatus === "completed") {
                  item.investigationStatus = "Approved";
                } else if (item?.investigationStatus === "rejected") {
                  item.investigationStatus = "Rejected";
                } else if (item?.investigatorDetails?.reassigned_to) {
                  item.investigatorDetails.reassigned_to = "Reassigned";
                } else if (item?.investigationStatus === "review") {
                  item.investigationStatus = item.investigatorDetails
                    .reassigned_to
                    ? "Reassigned"
                    : "Review";
                }
                arr[i] = {
                  vendor_names: item?.investigatorDetails?.vendor_name,
                  case_status:
                    item.investigatorDetails.reassigned_to ||
                    item?.investigationStatus,
                  view_blocks: "View Blocks",
                  re_assign:
                    item.investigatorDetails.reassigned_to !== "Reassigned"
                      ? "Re-assign"
                      : undefined,
                  withdraw:
                    item?.investigationStatus !== "Review" &&
                    item.investigatorDetails.reassigned_to !== "Reassigned"
                      ? "Withdraw"
                      : undefined,
                  mobile_number: item?.investigatorDetails?.mobile_number,
                  location: item?.investigatorDetails?.city,
                  email: item?.investigatorDetails?.email,
                  blocksAssigned: item?.investigatorDetails?.blocksAssigned,
                  caseAllocationId:
                    item?.investigatorDetails?.case_allocation_id,
                  srNo: i + 1,
                };
                return arr[i];
              }
            );
          setCaseManagementSegmentInfoState(venderDetailSegmentInfoData);
        } else if (
          secondTabVal !== "Recommendation" &&
          secondTabVal !== "FCU Actions" &&
          secondTabVal !== "Investigation"
        ) {
          // dispatch(isLoadingStateReducer(true));
          const data = await getAllCasesSegmentInfo(
            secondTabVal === "CHASE Smart"
              ? "External"
              : secondTabVal.split(" ")[0],
            {
              caseId: selectedCaseId.current,
            }
          );
          if (data?.success) {
            setShowSkeleton(true);
            let caseManagementSegmentInfoData = data?.data;
            if (secondTabVal === "Claim Details") {
              let documentsData = data?.data?.publicUrls;
              caseManagementSegmentInfoData = data.data.claimResult.map(
                (item, i, arr) => {
                  arr[i] = {
                    ...arr[i],
                    view_details: "View Details",
                    create_case: "Create Case",
                    documents: documentsData,
                    srNo: i + 1,
                  };
                  return arr[i];
                }
              );
            } else if (secondTabVal === "Risk Details") {
              caseManagementSegmentInfoData.triggers =
                caseManagementSegmentInfoData?.trigger?.map((item, index) => ({
                  ...item,
                  srNo: index + 1,
                })) || [];
            } else if (
              secondTabVal === "Dispatch Details" ||
              secondTabVal === "Endorsement Details"
            ) {
              caseManagementSegmentInfoData = data.data.map((item, i, arr) => {
                arr[i] = {
                  ...arr[i],
                  view_details: "View Details",
                  srNo: i + 1,
                };
                return arr[i];
              });
            }
            if (caseManagementSegmentInfoData?.policy_status) {
              if (caseManagementSegmentInfoData?.policy_status === true) {
                caseManagementSegmentInfoData.policy_status = "Active";
              } else if (
                caseManagementSegmentInfoData?.policy_status === false
              ) {
                caseManagementSegmentInfoData.policy_status = "In Active";
              }
            }
            setCaseManagementSegmentInfoState(caseManagementSegmentInfoData);
            if (
              caseManagementSegmentInfoData?.case_description &&
              descriptionRef.current
            ) {
              descriptionRef.current.value =
                caseManagementSegmentInfoData?.case_description;
            } else if (
              caseManagementSegmentInfoData[0] &&
              caseManagementSegmentInfoData[0]?.case_description &&
              descriptionRef.current
            ) {
              descriptionRef.current.value =
                caseManagementSegmentInfoData[0].case_description;
            } else if (descriptionRef.current) {
              descriptionRef.current.value = "";
            }
          } else {
            showToast("Error In Fetching Segment Info", "error", true);
            setCaseManagementSegmentInfoState({});
          }
          dispatch(isLoadingStateReducer(false));
        } else if (secondTabVal && secondTabVal === "FCU Actions") {
          getRlmuData(selectedCaseId?.current)
            .then((res) => {
              if (res?.success) {
                setRlmuData(res?.data);
              }
            })
            .catch((error) => showToast(error?.message, "error", true));
        } else if (secondTabVal === "Recommendation") {
          getDeEmpanelSegmentInfo(activeCaseId, recommendationName)
            .then((res) => {
              if (res?.success) {
                setRecommendationData(res?.data);
              }
            })
            .catch((err) => {
              dispatch(isLoadingStateReducer(false));
              showToast(err?.message, "error", true);
            });
        }
      } catch (error) {
        setCaseManagementSegmentInfoState({});
        dispatch(isLoadingStateReducer(false));
        showToast(
          error?.response?.data?.message || "Error In Fetching Segment Info",
          "error",
          true
        );
      }
    },
    [activeCaseId]
  );
  const debounceSegmentsApiCall = useCallback(
    debounce(getAllCasesSegmentInfoFun, 350),
    [activeCaseId]
  );
  useEffect(() => {
    setShowSkeleton(false);
  }, [secondTabVal]);
  useEffect(() => {
    if (displaySecondTab) {
      debounceSegmentsApiCall(secondTabVal);
    }
  }, [secondTabVal, displaySecondTab, rerenderSegmentApiState]);

  useEffect(() => {
    getAllCasesCount()
      .then((data) => {
        if (data?.success)
          if (userRole === "QC") {
            let casesCountForQC = getCaseManagementTablistItems(data?.data);
            casesCountForQC.splice(2, 1);
            setAllCasesCount(casesCountForQC);
          } else {
            setAllCasesCount(getCaseManagementTablistItems(data?.data));
          }
        else showToast("Error In getting cases count", "error", true);
      })
      .catch((err) => {
        setAllCasesCount(getCaseManagementTablistItems());
        showToast("Error In getting cases count", "error", true);
      });
    setReRender(false);
  }, [reRender, setReRender, caseManagementDataState]);
  useEffect(() => {
    if (!reRender) {
      const offset = (page - 1) * pageLimit;
      setIsLoading(true);
      getAllCasesList(firstTabVal, offset)
        .then((data) => {
          if (data?.success) {
            if (!data?.data?.caseList?.length)
              showToast("No Cases Found", "info", true);
            let caseManagementData = data.data.caseList.map((item, i, arr) => {
              arr[i] = {
                ...arr[i],
                recommendation_date: new Date(
                  item?.recommendation_date
                ).toLocaleDateString(),
                srNo: offset + i + 1,
                qc_status: item?.qc_status ? "Yes" : "No",
              };
              return arr[i];
            });
            setIsLoading(false);
            setCaseManagementDataState([...caseManagementData]);
            setCount(data.data.totalCases);
          } else {
            setCaseManagementDataState([]);
            showToast(data?.message || "Error in fetching list", "error", true);
          }
        })
        .catch((err) => {
          setIsLoading(false);
          setCaseManagementDataState([]);
          if (err?.response?.data?.message === "No such status exist.") {
            return showToast("Coming soon", "success", true);
          }
          showToast(
            err?.response?.data?.message || "Error in fetching list",
            "error",
            true
          );
        });
    }
  }, [firstTabVal, page, reRender]);

  const secondTabValueUpdater = useCallback(
    (firstTabValue, tabs2CaseManagementSubmitted) => {
      if (firstTabValue) {
        const updatedTabs = [...tabs2CaseManagementSubmitted];
        // Insert the new tab object at index 1
        updatedTabs.splice(1, 0, {
          label: "Investigation",
          border: "1px solid #E7373B",
          bg: "#E8505B",
        });
        return updatedTabs;
      }
    },
    []
  );

  // useEffect(() => {
  //   if (displaySecondTab) debouncedSearch(displaySecondTab);
  // }, [secondTabIndex, displaySecondTab, rerenderSegmentApiState]);
  useEffect(() => {
    if (userRole === "IM" || userRole === "QC" || firstTabVal === "Open") {
      ActionTabContent(firstTabVal, userRole);
    } else {
      setActionTabState([]);
    }
  }, [firstTabVal, userRole]);
  useEffect(() => {
    if (secondTabVal === "Vendor Details") {
      setTableCollapseDataState(
        caseManagementSegmentInfoState[selectedCollapseId]
      );
    } else if (caseManagementSegmentInfoState[selectedCollapseId]) {
      const columnData = segmentInfoDetails?.[secondTabVal]?.column?.map(
        (item) => item.id
      );

      const tableCollapseData = Object.keys(
        caseManagementSegmentInfoState[selectedCollapseId]
      )?.filter((item) => !columnData?.includes(item));

      const tableCollapseDataObj = {};
      tableCollapseData?.forEach((item) => {
        tableCollapseDataObj[item] =
          caseManagementSegmentInfoState[selectedCollapseId][item];
      });

      setTableCollapseDataState(tableCollapseDataObj);
    }
    if (isAllocatedCase) {
      dispatch(storeIsAllocatedCase(false));
    }
  }, [
    secondTabIndex,
    caseManagementSegmentInfoState,
    selectedCollapseId,
    isAllocatedCase,
  ]);

  useEffect(() => {
    if (secondTabVal === "Investigation") {
      setInvestigationActiveTabValue(-1);
    }
  }, [secondTabVal]);
  return (
    <Box className={style.caseManagementContainer}>
      <Box sx={boxStyle}>
        <Box sx={{ display: "block", width: "100%" }}>
          <Box className={style.box}>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "1.8rem",
                color: "#3A3A3A",
                // display: { xs: "none", sm: "block", md: "block" },
              }}
            >
              Case Management
            </Typography>
          </Box>
        </Box>
      </Box>
      {/* <div style={{display:"flex",flexDirection:"column",background:"red"}}> */}
      <Box sx={boxStyleTab}>
        <Box sx={matches ? match1 : match2}>
          <MuiTab
            tabs={AllCasesCount}
            onClick={firstTabChangeClickHandler}
            activeTab={firstTabIndex}
          />
          <div
            className={
              matches ? style.buttonClass : style["buttonClass--matches"]
            }
          >
            {userRole === "IM" && (
              <div className={style.boxButtonStyle}>
                <CommonButton
                  id="add-new-case"
                  label={matches ? "New case" : ""}
                  isIcon={true}
                  sx={createCaseStyle}
                  iconName={<img src={AddIcon} alt="Add Icon" />}
                  backgroundColor={"#FAFAFA"}
                  textColor={"#E42125"}
                  smallButton={true}
                  removeBorder={true}
                  filledButton={false}
                  removeBackGround={true}
                  onClick={newCaseClickHandler}
                />
              </div>
            )}
            <div style={{ width: "max-content" }}>
              <FilterPopOver
                isDateFilterClicked={isDateFilterClicked}
                isStatusFilterClicked={isStatusFilterClicked}
                isDateIconClicked={isDateIconClicked}
                isStatusIconClicked={isStatusIconClicked}
                isStatusItemClicked={isStatusItemClicked}
                anchorEl={anchorEl}
                dateFilterHandler={dateFilterHandler}
                statusFilterHandler={statusFilterHandler}
                statusItemHandler={statusItemHandler}
                startDateHandler={startDateHandler}
                endDateHandler={endDateHandler}
                handleFilterByTag={handleFilterByTag}
                handleClick={handleClick}
                handleClose={handleClose}
                handleFilterApply={handleFilterApply}
                handleFilterReset={handleFilterReset}
              />
            </div>
            <div style={{ width: "max-content" }}>
              <CommonButton
                label=""
                id="download-button"
                isIcon={true}
                iconName={
                  <img
                    src={DownloadIcon}
                    alt="Download Icon"
                    style={buttonStyle}
                  />
                }
                backgroundColor={"#ffffff"}
                textColor={"#E42125"}
                removeBorder={true}
                smallButton={true}
                filledButton={false}
                removeBackGround={true}
                onClick={() => showToast("Coming soon", "info", true)}
              />
            </div>
          </div>
        </Box>
        <CommonModal
          label={
            actionModalType === "Assign Block"
              ? "Assign Block"
              : actionModalType === "Case Description"
              ? "Case Description"
              : actionModalType === "Peer Review"
              ? "Peer Review"
              : actionModalType === "Re-Assign"
              ? "Re-assign to IM"
              : actionModalType === "Hold / Unhold"
              ? "Reason to hold"
              : ""
          }
          open={openActionModal}
          // showCrossIcon={
          //   actionModalType === "Approve" ||
          //   actionModalType === "Reject" ||
          //   actionModalType === "Re-open" ||
          //   actionModalType === "Submit Final"
          //     ? false
          //     : true
          // }
          showCrossIcon={true}
          width={
            actionModalType === "Upload Documents"
              ? "52rem"
              : actionModalType === "Assign Block"
              ? "60%"
              : actionModalType === "Raise Query"
              ? "30%"
              : actionModalType === "Case Description" ||
                actionModalType === "Case History"
              ? "60%"
              : actionModalType === "Vendor Assessment"
              ? "45%"
              : "30%" // default
          }
          height={
            actionModalType === "Assign Block"
              ? "75%"
              : actionModalType === "Grade Case"
              ? "45rem"
              : "auto"
          }
          onClose={() => setOpenActionModal(false)}
        >
          {renderActionComponent()}
        </CommonModal>
        {!isLoading ? (
          <TableComponent
            stickyHeader={false}
            columnHeaderBackgroundColor={"#FCF7FF"}
            columnHeaderColor={"#242424"}
            columnHeaderFontWeight={600}
            columnBodyFontWeight={400}
            page={page}
            rowsPerPage={rowsPerPage}
            count={count}
            firstButtonClicked={firstButtonClicked}
            lastButtonClicked={lastButtonClicked}
            handleNextButtonClick={handleNextButtonClick}
            handleBackButtonClick={handleBackButtonClick}
            onPageDropdownChange={onPageDropdownChange}
            setPage={setPage}
            alternnateStyledRow={true}
            alternnateStyledRowColor={"#FBF5FF"}
            rowsData={caseManagementDataState}
            columnsData={CaseManagementMainTableData?.[firstTabIndex]?.column}
            hideBorders={true}
            secondPopperListItem={actionTabState}
            // onClickSecondPopper={onClickSecondPopper}
            // onCloseSecondPopper={onCloseSecondPopper}
            onClickFirstPopper={onClickFirstPopper}
            onCellClicked={onCellClicked}
            // popperContentMatch={"caseNo"}
            popperContentMatch={"case_id"}
            // isDisabled={isDisabled}
            // firstTabIndex={firstTabIndex}
            // caseId={selectedCaseId}
            // displaySecondTab={displaySecondTab}
            // isColor={true}
            activeMenu="caseManagement"
            firstTabVal={firstTabVal}
            caseId={activeCaseId}
            displaySecondTab={displaySecondTab}
            openActionModal={openActionModal}
            actionPopperRef={actionPopperRef}
          />
        ) : (
          <TableSkeleton />
        )}
        {displaySecondTab ? (
          <>
            <MuiTab
              tabs={
                firstTabVal === "Allocated"
                  ? tabs2CaseManagementVendor
                  : firstTabVal === "Recommended" &&
                    recommendationName !== "police"
                  ? tabs2CaseManagementRecommended
                  : firstTabVal === "QC" || firstTabVal === "Rejected"
                  ? tabs2CaseManagementSubmitted
                  : firstTabVal === "Submitted"
                  ? secondTabValueUpdater(
                      firstTabVal,
                      tabs2CaseManagementSubmitted
                    )
                  : tabs2CaseManagement
              }
              variant="standard"
              onClick={secondTabChangeClickHandler}
              ref={viewTableRef}
              id={secondTabVal}
            />
            <Box sx={{ marginTop: "10px" }}>
              {gridViewTabs.includes(secondTabVal) ? (
                Object.keys(caseManagementSegmentInfoState).length &&
                showSkeleton ? (
                  <TableGrid
                    gridContent={
                      caseManagementSegmentInfoState[0]
                        ? caseManagementSegmentInfoState[0]
                        : caseManagementSegmentInfoState
                    }
                    isDocument={
                      caseManagementSegmentInfoState?.documents?.length
                        ? true
                        : false
                    }
                    backgroundColor="#FFFFFF"
                    boxShadow="0px 5px 25px rgba(0, 0, 0, 0.06)"
                    documentDetails={caseManagementSegmentInfoState?.documents}
                  />
                ) : (
                  <TableGridSkeleton />
                )
              ) : secondTabVal === "CHASE Smart" ? (
                Object.keys(caseManagementSegmentInfoState).length &&
                showSkeleton ? (
                  <ExternalInformation
                    backgroundColor="#FFFFFF"
                    boxShadow="0px 5px 25px rgba(0, 0, 0, 0.06)"
                    data={caseManagementSegmentInfoState}
                    documentDetails={
                      segmentInfoDetails?.[secondTabVal]?.documentDetails
                    }
                  />
                ) : (
                  <TableGridSkeleton showProfileSkeleton />
                )
              ) : secondTabVal === "Vendor Details" ? (
                <>
                  <div
                    style={{
                      boxShadow: "0px 5px 25px rgba(0, 0, 0, 0.06)",
                    }}
                  >
                    <TableComponent
                      rowsData={caseManagementSegmentInfoState}
                      columnsData={
                        userRole === "IM"
                          ? segmentInfoDetails?.[secondTabVal]?.column
                          : segmentInfoDetails?.[secondTabVal]?.column.filter(
                              (column) => column.id !== "withdraw"
                            )
                      }
                      hideColumnWithId={userRole !== "IM" ? "re_assign" : null}
                      TableCollapseContent={tableCollapseDataState}
                      onCellClicked={onCellClicked}
                      open={openCollapse}
                      setOpen={setOpenCollapse}
                      vendorDetailsTab={true}
                      TableCollapseContentDocument={false}
                      tablePagination={false}
                      paddingLeftHeaderStyledTableCell="3px"
                      paddingHeaderStyledTableCell="10.5px"
                      paddingBodyStyledTableCell="15.5px"
                      paddingLeftBodyStyledTableCell="5px"
                      columnHeaderColor={"#666666"}
                      columnHeaderFont="1.1rem"
                      columnHeaderFontWeight={400}
                      columnBodyColor={"#3A3A3A"}
                      columnBodyFont="1.2rem"
                      columnBodyFontWeight={500}
                      paddingBody=".5rem"
                      paddingHeader=".75rem"
                      tablePadding="0rem"
                      vendorDetailPadding="16px 32px"
                      vendorDetailBorderRadius="4px"
                      vendorDetailBorder="1px solid #E8E8E8"
                      isCheckbox={false}
                    />
                  </div>
                  <CommonModal
                    label="Re-assign Case"
                    open={reAssignModal}
                    onClose={() => {
                      setReAssignModal(false);
                    }}
                    width="42.1rem"
                    height="28rem"
                  >
                    <Approval
                      message=""
                      isReassign={true}
                      onReassignClick={(type) => {
                        dispatch(storeIsAllocatedCase(true));
                        navigate(
                          `/re-assign/${vendorDetailIndexNumber}/${type}`
                        );
                      }}
                    />
                  </CommonModal>
                  <CommonModal
                    open={withdrawModal}
                    onClose={() => setWithdrawModal(false)}
                    showCrossIcon
                  >
                    <PromptModal
                      title="Are you sure you want to Withdraw the case ?"
                      submitHandler={(inputValue) => {
                        if (inputValue?.trim().length) {
                          withdrawalCaseFunc(caseId, inputValue);
                        } else {
                          showToast("Please fill the remark", "error", true);
                        }
                      }}
                      handleNoClick={() => setWithdrawModal(false)}
                    />
                  </CommonModal>
                </>
              ) : secondTabVal === "Recommendation" ? (
                <RecommendationTabelGrid
                  gridContent={recommendationData || {}}
                  secondTabVal={secondTabVal}
                  firstTabVal={
                    recommendationName?.charAt(0)?.toUpperCase() +
                    recommendationName?.slice(1)
                  }
                  selectedCaseData={caseManagementDataState?.find(
                    (obj) => obj?.case_id == selectedCaseId?.current
                  )}
                />
              ) : secondTabVal === "FCU Actions" ? (
                <RecommendationTabelGrid
                  selectedCaseData={caseManagementDataState?.find(
                    (obj) => obj?.case_id == activeCaseId
                  )}
                  gridContent={{ rlmu: rlmuData }}
                  firstTabVal={firstTabVal}
                  secondTabVal={secondTabVal}
                />
              ) : secondTabVal === "Investigation" ? (
                <Investigation
                  caseId={selectedCaseId?.current}
                  investigationsActiveTabValue={investigationsActiveTabValue}
                  setInvestigationActiveTabValue={
                    setInvestigationActiveTabValue
                  }
                  setVendorBlockIsClicked={setVendorBlockIsClicked}
                  vendorBlockisClicked={vendorBlockisClicked}
                  setIsVendorClicked={setIsVendorClicked}
                  isVendorClicked={isVendorClicked}
                  firstTabIndex={firstTabIndex}
                  secondTabIndex={secondTabIndex}
                  setRerenderApprovalCaseList={() => {}}
                  firstTabVal={firstTabVal}
                />
              ) : Object.keys(caseManagementSegmentInfoState).length &&
                showSkeleton ? (
                <TableComponent
                  rowsData={caseManagementSegmentInfoState}
                  hideColumnWithId={userRole !== "IM" ? "create_case" : null}
                  columnsData={segmentInfoDetails?.[secondTabVal]?.column}
                  TableCollapseContent={tableCollapseDataState}
                  onCellClicked={onCellClicked}
                  open={openCollapse}
                  setOpen={setOpenCollapse}
                  TableCollapseContentDocument={false}
                  tablePagination={false}
                  hideBorders={true}
                  paddingLeftHeaderStyledTableCell="3px"
                  paddingHeaderStyledTableCell="4.5px"
                  paddingBodyStyledTableCell="4.5px"
                  columnHeaderColor={"#E42125"}
                  columnHeaderFont="1.2rem"
                  columnHeaderFontWeight={600}
                  columnBodyFont="1.2rem"
                  columnBodyFontWeight={500}
                  paddingBody=".5rem"
                  paddingHeader=".75rem"
                  tableBoxShadow="0px 5px 25px rgba(0, 0, 0, 0.06)"
                  tableBorder={""}
                  tablePadding="1.5rem 0rem"
                  createCaseClickHandler={newCaseClickHandler}
                />
              ) : (
                <TableGridSkeleton />
              )}
              {secondTabVal === "Risk Details" && (
                <Box>
                  <Typography
                    sx={{
                      font: "Inter",
                      fontWeight: 500,
                      fontSize: "1.4rem",
                      color: "#505050",
                      margin: "15px 0 10px 0",
                    }}
                  >
                    {lobName?.toLowerCase() === "motor"
                      ? "Motor Trigger"
                      : "Health Trigger"}
                  </Typography>
                  {Object.keys(caseManagementSegmentInfoState)?.length &&
                  showSkeleton ? (
                    <TableComponent
                      stickyHeader={false}
                      columnHeaderBackgroundColor={"#FFDFCB"}
                      columnHeaderColor={"#242424"}
                      columnHeaderFontWeight={600}
                      columnBodyFontWeight={400}
                      rowsData={caseManagementSegmentInfoState?.triggers || []}
                      columnsData={motorTriggerTable?.column}
                      hideBorders={true}
                      tablePagination={false}
                      isNoDataRow={true}
                    />
                  ) : (
                    <TableSkeleton rows={1} pagination={false} />
                  )}
                </Box>
              )}
              {![
                "Vendor Details",
                "FCU Actions",
                "Recommendation",
                "Investigation",
              ].includes(secondTabVal) && (
                <CommonDescription
                  onSubmitButton={onSubmitButton}
                  descriptionRef={descriptionRef}
                />
              )}
            </Box>
          </>
        ) : null}
      </Box>
    </Box>
  );
};

export default CaseManagement;
